import { render, staticRenderFns } from "./bullet-point.vue?vue&type=template&id=47b5d68a&scoped=true&"
import script from "./bullet-point.vue?vue&type=script&lang=js&"
export * from "./bullet-point.vue?vue&type=script&lang=js&"
import style0 from "./bullet-point.vue?vue&type=style&index=0&id=47b5d68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5d68a",
  null
  
)

export default component.exports